/* Nordestic · Schlichte Produktseite. Kein Framework, keine externen Abhängigkeiten. */
(() => {
  if (window.__nordesticClean) return;
  window.__nordesticClean = true;

  const $ = (sel, el = document) => el.querySelector(sel);
  const $$ = (sel, el = document) => [...el.querySelectorAll(sel)];

  const track = (prefix, name, data = {}) => {
    const event = `${prefix || 'nordestic_clean'}_${name}`;
    try { window.Shopify?.analytics?.publish?.(event, data); } catch {}
    try { (window.dataLayer = window.dataLayer || []).push({event, ...data}); } catch {}
    document.dispatchEvent(new CustomEvent('nordestic:track', {detail: {event, ...data}}));
  };

  /* ---------- Geldformat: aus einem Shopify-formatierten Beispiel ableiten ---------- */
  const makeMoney = (sample, currency) => {
    const text = sample?.text || '';
    const m = text.match(/\d[\d.,'’\s]*\d|\d/);
    let decimal = ',', group = '.';
    if (m) {
      const num = m[0];
      const tail = num.match(/([.,])(\d{2})$/);
      if (tail) decimal = tail[1];
      const g = num.slice(0, tail ? -3 : undefined).match(/[.,'’\s]/);
      group = g ? g[0] : (decimal === ',' ? '.' : ',');
      if (group === decimal) group = decimal === ',' ? '.' : ',';
    }
    const hasDecimals = m ? /[.,]\d{2}$/.test(m[0]) : true;
    return cents => {
      const v = Math.max(0, Math.round(cents)) / 100;
      const [int, dec] = v.toFixed(2).split('.');
      const intG = int.replace(/\B(?=(\d{3})+(?!\d))/g, group);
      const n = hasDecimals ? `${intG}${decimal}${dec}` : intG;
      if (m) return text.slice(0, m.index) + n + text.slice(m.index + m[0].length);
      try { return new Intl.NumberFormat('de-DE', {style: 'currency', currency}).format(v); } catch { return n; }
    };
  };

  /* ---------- Lieferdatum (Kalendertage, Europe/Berlin) ---------- */
  const berlinToday = () => {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date());
    const [y, mo, d] = parts.split('-').map(Number);
    return new Date(Date.UTC(y, mo - 1, d));
  };
  const deliveryText = (min, max) => {
    const base = berlinToday();
    const wd = n => { const d = new Date(base); while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); const w = d.getUTCDay(); if (w !== 0 && w !== 6) n--; } return d; };
    const a = wd(min);
    const b = wd(max);
    const month = dt => new Intl.DateTimeFormat('de-DE', {month: 'long', timeZone: 'UTC'}).format(dt);
    const dd = dt => String(dt.getUTCDate()).padStart(2, '0');
    if (a.getUTCMonth() === b.getUTCMonth()) return `${dd(a)}.–${dd(b)}. ${month(b)}`;
    return `${dd(a)}. ${month(a)} – ${dd(b)}. ${month(b)}`;
  };
  const initDelivery = root => $$('[data-ncl-delivery]', root).forEach(el => {
    const min = Number(el.dataset.min) || 3, max = Math.max(Number(el.dataset.max) || 5, min);
    el.textContent = deliveryText(min, max);
  });

  /* ---------- Schweizer Schreibweise ---------- */
  const swissSpelling = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) if (node.nodeValue.includes('ß')) node.nodeValue = node.nodeValue.replace(/ß/g, 'ss');
    $$('[aria-label]', root).forEach(el => { const v = el.getAttribute('aria-label'); if (v.includes('ß')) el.setAttribute('aria-label', v.replace(/ß/g, 'ss')); });
  };

  /* ---------- Dialoge ---------- */
  const initDialogs = root => {
    $$('[data-ncl-dialog-open]', root).forEach(btn => btn.addEventListener('click', () => {
      const d = document.getElementById(btn.dataset.nclDialogOpen);
      if (d?.showModal) d.showModal();
    }));
    $$('dialog', root).forEach(d => {
      d.addEventListener('click', e => { if (e.target === d || e.target.closest('[data-ncl-dialog-close]')) d.close(); });
    });
  };

  /* ---------- Galerie ---------- */
  const initGallery = (root, data) => {
    const trackEl = $('[data-ncl-track]', root);
    if (!trackEl) return {goToMedia() {}};
    const slides = $$('[data-ncl-slide]', trackEl);
    const thumbs = $$('[data-ncl-thumb]', root);
    const count = $('[data-ncl-count]', root);
    let index = 0;
    const setActive = i => {
      index = i;
      thumbs.forEach((t, n) => { t.classList.toggle('is-active', n === i); if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (count) count.textContent = `${i + 1} / ${slides.length}`;
      const active = thumbs[i];
      if (active) { const box = active.parentElement; const top = active.offsetTop - box.clientHeight / 2 + active.clientHeight / 2; box.scrollTo({top, behavior: 'smooth'}); }
      slides.forEach((s, n) => { const v = $('video', s); if (v && n !== i && !v.paused) v.pause(); });
    };
    const go = (i, smooth = true) => {
      const n = (i + slides.length) % slides.length;
      trackEl.scrollTo({left: trackEl.clientWidth * n, behavior: smooth ? 'smooth' : 'auto'});
      setActive(n);
    };
    let t;
    trackEl.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => setActive(Math.round(trackEl.scrollLeft / Math.max(1, trackEl.clientWidth))), 60); }, {passive: true});
    thumbs.forEach((th, n) => th.addEventListener('click', () => go(n)));
    $('[data-ncl-prev]', root)?.addEventListener('click', () => go(index - 1));
    $('[data-ncl-next]', root)?.addEventListener('click', () => go(index + 1));
    trackEl.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') go(index - 1); if (e.key === 'ArrowRight') go(index + 1); });
    window.addEventListener('resize', () => go(index, false));

    // Lightbox
    const lb = $('[data-ncl-lightbox]', root);
    const lbImg = $('[data-ncl-lightbox-img]', root);
    const images = slides.map(s => $('img[data-full]', s)).filter(Boolean);
    let lbIndex = 0;
    const showLb = i => { lbIndex = (i + images.length) % images.length; lbImg.src = images[lbIndex].dataset.full; lbImg.alt = images[lbIndex].alt; };
    $$('[data-ncl-zoom]', root).forEach(z => z.addEventListener('click', () => {
      const img = $('img', z); const i = images.indexOf(img);
      if (!lb?.showModal || i < 0) return;
      showLb(i); lb.showModal(); track(data.trackPrefix, 'zoom');
    }));
    $('[data-ncl-lb-prev]', root)?.addEventListener('click', () => showLb(lbIndex - 1));
    $('[data-ncl-lb-next]', root)?.addEventListener('click', () => showLb(lbIndex + 1));
    lb?.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') showLb(lbIndex - 1); if (e.key === 'ArrowRight') showLb(lbIndex + 1); });

    const initial = slides.findIndex(s => s.classList.contains('is-start'));
    return {
      goToMedia(mediaId) {
        if (!mediaId) return;
        const i = slides.findIndex(s => String(s.dataset.mediaId) === String(mediaId));
        if (i >= 0) go(i);
      },
      start(mediaId) {
        const i = slides.findIndex(s => String(s.dataset.mediaId) === String(mediaId));
        if (i > 0) requestAnimationFrame(() => go(i, false));
        else if (initial > 0) go(initial, false);
      },
    };
  };

  /* ---------- Kaufbereich ---------- */
  const initProduct = root => {
    const dataEl = $('[data-ncl-data]', root);
    if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const money = makeMoney(data.moneySample, data.currency);
    const gallery = initGallery(root, data);
    const form = $('[data-ncl-form]', root);
    const idInput = $('[data-ncl-variant-input]', root);
    const qtyInput = $('[data-ncl-qty-input]', root);
    const addBtn = $('[data-ncl-add]', root);
    const addLabel = $('[data-ncl-add-label]', root);
    const addPrice = $('[data-ncl-add-price]', root);
    const err = $('[data-ncl-error]', root);
    const fieldsets = $$('[data-ncl-option]', root);
    let variant = data.variants.find(v => String(v.id) === String(idInput?.value)) || data.variants[0];

    const selected = () => fieldsets.map(fs => $('input:checked', fs)?.value);
    const findVariant = opts => data.variants.find(v => v.options.every((o, i) => o === opts[i]));
    const qty = () => Math.min(20, Math.max(1, parseInt(qtyInput?.value, 10) || 1));

    const markAvailability = () => {
      const cur = selected();
      fieldsets.forEach((fs, oi) => {
        $$('.ncl-choice', fs).forEach(label => {
          const input = $('input', label);
          const test = cur.slice(); test[oi] = input.value;
          const v = findVariant(test);
          const ok = !!(v && v.available);
          label.classList.toggle('is-unavailable', !ok);
          if (!ok) input.setAttribute('aria-label', `${input.value} – nicht verfügbar`); else input.removeAttribute('aria-label');
        });
      });
    };

    const render = (fromUser = false) => {
      const v = variant;
      if (idInput && v) idInput.value = v.id;
      const q = qty();
      const price = v ? v.price : 0;
      $('[data-ncl-price-now]', root).textContent = money(price);
      const was = $('[data-ncl-price-was]', root), save = $('[data-ncl-price-save]', root);
      const hasCompare = v && v.compare > v.price;
      was.hidden = save.hidden = !hasCompare;
      if (hasCompare) { was.textContent = money(v.compare); save.textContent = `${money(v.compare - v.price).replace(/[.,]00(?!\d)/, '')} sparen`; }
      if (addPrice) addPrice.textContent = money(price * q);
      const available = !!(v && v.available);
      addBtn.disabled = !available;
      addLabel.textContent = !v ? 'Nicht verfügbar' : available ? 'In den Warenkorb' : 'Ausverkauft';
      const title = v ? v.options.join(' · ') : '';
      const summary = $('[data-ncl-summary]', root); if (summary && fieldsets.length) summary.textContent = title;
      const sv = $('[data-ncl-sticky-variant]', root); if (sv && fieldsets.length) sv.textContent = title;
      const sp = $('[data-ncl-sticky-price]', root); if (sp) sp.textContent = money(price * q);
      const sb = $('[data-ncl-sticky-add]', root); if (sb) sb.disabled = !available;
      fieldsets.forEach((fs, i) => { const out = $('[data-ncl-option-value]', fs); if (out) out.textContent = selected()[i] || ''; });
      markAvailability();
      if (fromUser && v) {
        if (v.media) gallery.goToMedia(v.media);
        try {
          const url = new URL(location.href); url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url);
        } catch {}
      }
    };

    fieldsets.forEach(fs => fs.addEventListener('change', () => {
      const opts = selected();
      variant = findVariant(opts);
      if (!variant) {
        // Kombination gibt es nicht: nächste verfügbare Variante mit der zuletzt gewählten Option
        const changed = fieldsets.indexOf(fs);
        variant = data.variants.find(v => v.available && v.options[changed] === opts[changed]) || data.variants.find(v => v.options[changed] === opts[changed]);
        if (variant) fieldsets.forEach((f, i) => { const input = $$('input', f).find(x => x.value === variant.options[i]); if (input) input.checked = true; });
      }
      render(true);
      track(data.trackPrefix, 'option', {variant: variant?.id});
    }));

    const setQty = n => { if (qtyInput) { qtyInput.value = Math.min(20, Math.max(1, n)); render(); } };
    $('[data-ncl-qty-minus]', root)?.addEventListener('click', () => setQty(qty() - 1));
    $('[data-ncl-qty-plus]', root)?.addEventListener('click', () => setQty(qty() + 1));
    qtyInput?.addEventListener('change', () => setQty(qty()));

    const cartRoot = (data.cartRoot || '/').replace(/\/?$/, '/');
    const add = async source => {
      if (!variant || !variant.available) return;
      err.hidden = true;
      addBtn.classList.add('is-loading'); addBtn.disabled = true;
      try {
        const res = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: variant.id, quantity: qty()}]}),
        });
        if (!res.ok) {
          let msg = 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.';
          try { const j = await res.json(); if (j.description) msg = j.description; } catch {}
          throw new Error(msg);
        }
        track(data.trackPrefix, 'add_to_cart', {variant: variant.id, quantity: qty(), source});
        const ev = new CustomEvent('nordestic:cart-added', {cancelable: true, detail: {cartUrl: cartRoot + 'cart', variantId: variant.id, quantity: qty()}});
        const handled = !document.dispatchEvent(ev);
        if (!handled) location.assign(cartRoot + 'cart');
      } catch (e) {
        err.textContent = e.message; err.hidden = false;
      } finally {
        addBtn.classList.remove('is-loading'); addBtn.disabled = !variant?.available;
      }
    };
    form?.addEventListener('submit', e => { e.preventDefault(); add('buy'); });
    $('[data-ncl-sticky-add]', root)?.addEventListener('click', () => add('sticky'));

    // Sticky-Leiste erst zeigen, wenn der Button nicht mehr sichtbar ist
    const sticky = $('[data-ncl-sticky]', root);
    if (sticky && addBtn) {
      sticky.hidden = false;
      let on = null, queued = false;
      const check = () => {
        queued = false;
        const below = addBtn.getBoundingClientRect().bottom < 0;
        if (below === on) return;
        on = below;
        sticky.classList.toggle('is-on', below);
        sticky.setAttribute('aria-hidden', below ? 'false' : 'true');
        sticky.inert = !below;
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(check); } };
      addEventListener('scroll', schedule, {passive: true});
      addEventListener('resize', schedule, {passive: true});
      check();
    }

    $$('[data-ncl-jump]', root).forEach(a => a.addEventListener('click', e => {
      const target = document.querySelector(a.dataset.nclTarget || a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
      window.scrollTo({top: target.getBoundingClientRect().top + scrollY - header - 12, behavior: 'smooth'});
    }));

    // Start-Variante aus der URL (?variant=…)
    try {
      const vid = new URL(location.href).searchParams.get('variant');
      const fromUrl = vid && data.variants.find(v => String(v.id) === vid);
      if (fromUrl) {
        variant = fromUrl;
        fieldsets.forEach((f, i) => { const input = $$('input', f).find(x => x.value === variant.options[i]); if (input) input.checked = true; });
      }
    } catch {}
    gallery.start(variant?.media);
    render();
    initDialogs(root);
  };

  /* ---------- Bewertungen (Judge.me) ---------- */
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const stripHtml = s => { const d = document.createElement('div'); d.innerHTML = String(s || '').replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>\s*<p>/gi, '\n\n'); return (d.textContent || '').trim(); };
  // R36: gemeinsamer Judge.me-Abruf (Bewertungen, Kundenfotos im Kaufbereich und „… bei euch“)
  const judgeCache = new Map();
  const judgeRoot = () => document.querySelector('[data-ncl-reviews]');
  const judgeFetch = page => {
    const root = judgeRoot();
    const {shop, token, product} = root?.dataset || {};
    if (!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(shop || '') || !token) return Promise.reject(new Error('reviews'));
    if (!judgeCache.has(page)) {
      const url = new URL('https://judge.me/api/v1/widgets/product_review');
      url.search = new URLSearchParams({shop_domain: shop, api_token: token, external_id: product, json_request: 'true', page: String(page), per_page: '30'});
      judgeCache.set(page, fetch(url, {credentials: 'omit', referrerPolicy: 'no-referrer'}).then(r => { if (!r.ok) throw new Error('reviews'); return r.json(); }));
    }
    return judgeCache.get(page);
  };
  let photoPromise = null;
  const judgePhotos = () => photoPromise || (photoPromise = (async () => {
    const all = [];
    let page = 1, pages = 1;
    do {
      const j = await judgeFetch(page);
      pages = Math.min(3, j.total_pages || 1);
      (j.reviews || []).forEach(r => (r.pictures_urls || []).forEach(p => all.push({review: r, src: p.huge || p.original || p.compact, thumb: p.compact || p.small || p.original})));
      page += 1;
    } while (page <= pages && all.length < 12);
    return all.filter(p => p.src);
  })().catch(() => []));
  const showReviewPhotos = () => {
    const root = judgeRoot(); if (!root) return;
    root.querySelector('[data-ncl-review-filter] [data-filter="photos"]')?.click();
    const header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
    window.scrollTo({top: root.getBoundingClientRect().top + scrollY - header - 12, behavior: 'smooth'});
  };
  const shortQuote = t => { t = String(t || '').replace(/\s+/g, ' ').trim(); if (t.length <= 130) return t; const cut = t.slice(0, 130); return cut.slice(0, cut.lastIndexOf(' ')) + ' …'; };

  const initPhotoTeaser = async el => {
    const photos = await judgePhotos();
    if (!photos.length) return;
    const count = photos.length >= 12 ? '12+' : String(photos.length);
    el.querySelector('[data-ncl-photo-count]').textContent = `${count} Kundenfoto${photos.length === 1 ? '' : 's'}`;
    el.querySelector('[data-ncl-avatars]').innerHTML = photos.slice(0, 3).map(p => `<img src="${esc(p.thumb)}" alt="" width="32" height="32" loading="lazy">`).join('');
    el.hidden = false;
    el.addEventListener('click', e => {
      const ugc = document.getElementById('ncl-ugc');
      e.preventDefault();
      if (ugc && !ugc.hidden) { const header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80; window.scrollTo({top: ugc.getBoundingClientRect().top + scrollY - header - 12, behavior: 'smooth'}); }
      else showReviewPhotos();
    });
  };

  const initUgc = async root => {
    const photos = await judgePhotos();
    if (!photos.length) return;
    const allVerified = judgeRoot()?.dataset.allVerified === '1';
    const byReview = [];
    photos.forEach(p => { if (!byReview.find(x => x.review === p.review)) byReview.push(p); });
    const best = byReview.slice().sort((a, b) => (Number(b.review.rating) || 0) - (Number(a.review.rating) || 0) || String(a.review.body || '').length - String(b.review.body || '').length)[0];
    const r = best.review;
    const name = r.is_anonymous_reviewer ? 'Anonym' : (r.reviewer_name || 'Kundin');
    const quote = shortQuote(r.body || stripHtml(r.body_html) || r.title);
    root.querySelector('[data-ncl-ugc-quote]').textContent = `„${quote}“`;
    root.querySelector('[data-ncl-ugc-author]').textContent = `${name}${allVerified || r.verified_buyer ? ' · Verifizierter Kauf' : ''}`;
    const tiles = byReview.slice(0, 3);
    root.querySelector('[data-ncl-ugc-photos]').innerHTML = tiles.map((p, i) => {
      const n = p.review.is_anonymous_reviewer ? 'Anonym' : (p.review.reviewer_name || '');
      return `<figure class="ncl-ugc-tile"><button type="button" data-ncl-ugc-open aria-label="Kundenfoto von ${esc(n)} in den Bewertungen ansehen"><img src="${esc(p.src)}" alt="Kundenfoto von ${esc(n)}" loading="lazy" width="600" height="600"></button><figcaption><span>Bei ${esc(n)}</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7M8 7h9v9"/></svg></figcaption></figure>`;
    }).join('');
    const all = root.querySelector('[data-ncl-ugc-all]');
    if (all) all.firstChild.textContent = `Alle ${photos.length >= 12 ? '12+' : photos.length} Kundenfotos ansehen`;
    $$('[data-ncl-ugc-open], [data-ncl-ugc-all], [data-ncl-ugc-read]', root).forEach(b => b.addEventListener('click', e => { e.preventDefault(); showReviewPhotos(); }));
    root.hidden = false;
  };

  const initReviews = async root => {
    const list = $('[data-ncl-review-list]', root);
    const more = $('[data-ncl-review-more]', root);
    const empty = $('[data-ncl-review-empty]', root);
    const filterBar = $('[data-ncl-review-filter]', root);
    const {shop, token, product} = root.dataset;
    const allVerified = root.dataset.allVerified === '1';
    const pageSize = Number(root.dataset.pageSize) || 6;
    if (!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(shop || '') || !token) { empty.hidden = false; return; }
    let reviews = [], shown = 0, filter = 'all', total = 0;
    const fetchPage = judgeFetch;
    const card = r => {
      const date = r.created_at ? new Date(r.created_at).toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: 'numeric'}) : '';
      const verified = allVerified || r.verified_buyer === true;
      const photos = (r.pictures_urls || []).slice(0, 4).map(p => `<img src="${esc(p.compact || p.small || p.original)}" alt="Kundenfoto von ${esc(r.reviewer_name)}" loading="lazy" width="64" height="64">`).join('');
      const reply = r.reply_content ? stripHtml(r.reply_content) : '';
      const n = Math.max(0, Math.min(5, Number(r.rating) || 0));
      return `<li class="ncl-review"><div class="ncl-review-top"><strong>${esc(r.is_anonymous_reviewer ? 'Anonym' : r.reviewer_name)}</strong><span class="ncl-review-date">${esc(date)}</span></div>`
        + (verified ? `<span class="ncl-review-verified"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>Verifizierter Kauf</span>` : '')
        + `<span class="ncl-stars" role="img" aria-label="${n} von 5 Sternen">${'★'.repeat(n)}${'☆'.repeat(5 - n)}</span>`
        + (r.title ? `<h3>${esc(r.title)}</h3>` : '')
        + `<p>${esc(r.body || stripHtml(r.body_html))}</p>`
        + (photos ? `<div class="ncl-review-photos">${photos}</div>` : '')
        + (reply ? `<div class="ncl-review-reply"><strong>Antwort von Nordestic</strong>${esc(reply).replace(/\n+/g, '<br>')}</div>` : '')
        + `</li>`;
    };
    const visible = () => filter === 'photos' ? reviews.filter(r => (r.pictures_urls || []).length) : reviews;
    const draw = () => {
      const items = visible();
      list.innerHTML = items.slice(0, shown).map(card).join('');
      const rest = (filter === 'all' ? Math.max(total, items.length) : items.length) - shown;
      more.hidden = rest <= 0;
      more.textContent = `Weitere ${Math.min(pageSize, rest)} Bewertungen lesen`;
      empty.hidden = items.length > 0;
    };
    try {
      let page = 1, pages = 1;
      const first = await fetchPage(page);
      pages = first.total_pages || 1;
      reviews = first.reviews || [];
      total = pages > 1 ? Number(root.querySelector('[data-ncl-score-count]')?.textContent.match(/\d+/)?.[0]) || reviews.length : reviews.length;
      shown = Math.min(pageSize, reviews.length);
      filterBar.hidden = !reviews.some(r => (r.pictures_urls || []).length);
      draw();
      more.addEventListener('click', async () => {
        const need = shown + pageSize;
        while (visible().length < need && page < pages) { page += 1; try { reviews = reviews.concat((await fetchPage(page)).reviews || []); } catch { break; } }
        if (page >= pages) total = reviews.length;
        shown = Math.min(need, visible().length);
        draw();
      });
      $$('button', filterBar).forEach(b => b.addEventListener('click', () => {
        filter = b.dataset.filter; shown = Math.min(pageSize, visible().length);
        $$('button', filterBar).forEach(x => x.classList.toggle('is-active', x === b));
        draw();
      }));
      if (!reviews.length) root.querySelector('[data-ncl-score]')?.setAttribute('hidden', '');
    } catch {
      empty.textContent = 'Bewertungen sind gerade nicht erreichbar.';
      empty.hidden = false;
    }
  };

  /* ---------- Weitere Designs ---------- */
  const initRelated = async root => {
    const cards = $('[data-ncl-cards]', root);
    const exclude = String(root.dataset.exclude);
    if (!cards.children.length && root.dataset.url) {
      try {
        const r = await fetch(root.dataset.url, {headers: {Accept: 'application/json'}});
        const j = await r.json();
        const products = (j.products || []).filter(p => String(p.id) !== exclude && p.available !== false).slice(0, Number(root.dataset.limit) || 8);
        const money = makeMoney({text: document.querySelector('[data-ncl-price-now]')?.textContent || ''}, 'EUR');
        const moneyCents = p => typeof p.price === 'number' ? p.price : Math.round(parseFloat(p.price) * 100);
        cards.innerHTML = products.map(p => {
          const img = p.featured_image ? (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.url) : '';
          const src = img ? `${img}${img.includes('?') ? '&' : '?'}width=600` : '';
          return `<li class="ncl-card"><a href="${esc(p.url)}"><span class="ncl-card-img">${src ? `<img src="${esc(src)}" alt="${esc(p.title)}" loading="lazy" width="600" height="600">` : ''}</span><span class="ncl-card-title">${esc(p.title)}</span><span class="ncl-card-price">${p.price_varies ? 'ab ' : ''}${esc(money(moneyCents(p)))}</span></a></li>`;
        }).join('');
      } catch {}
    }
    if (!cards.children.length) { root.hidden = true; return; }
    const prev = $('[data-ncl-rel-prev]', root), next = $('[data-ncl-rel-next]', root);
    const update = () => { prev.disabled = cards.scrollLeft < 4; next.disabled = cards.scrollLeft + cards.clientWidth >= cards.scrollWidth - 4; };
    prev.addEventListener('click', () => cards.scrollBy({left: -cards.clientWidth, behavior: 'smooth'}));
    next.addEventListener('click', () => cards.scrollBy({left: cards.clientWidth, behavior: 'smooth'}));
    cards.addEventListener('scroll', update, {passive: true});
    update();
  };

  const init = () => {
    $$('[data-ncl-product]').forEach(initProduct);
    initDelivery(document);
    document.querySelectorAll('[data-n-ssr]').forEach(el => el.remove());
    $$('[data-ncl-reviews]').forEach(initReviews);
    $$('[data-ncl-photo-teaser]').forEach(initPhotoTeaser);
    $$('[data-ncl-ugc]').forEach(initUgc);
    $$('[data-ncl-related]').forEach(initRelated);
    const swiss = document.querySelector('[data-ncl-product][data-swiss="1"]');
    if (swiss) {
      const apply = () => $$('.ncl').forEach(swissSpelling);
      apply();
      new MutationObserver(() => { clearTimeout(apply.t); apply.t = setTimeout(apply, 50); }).observe(document.querySelector('main') || document.body, {subtree: true, childList: true});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* R142: Handy – Punkte zeigen, dass es mehrere Bilder gibt und welches gerade zu sehen ist */
(() => {
  const init = () => document.querySelectorAll('.ncl .ncl-stage').forEach(stage => {
    const track = stage.querySelector('[data-ncl-track]');
    if (!track || (stage.nextElementSibling && stage.nextElementSibling.classList.contains('n-gdots')) || track.children.length < 2) return;
    const dots = document.createElement('div'); dots.className = 'n-gdots'; dots.setAttribute('aria-hidden', 'true');
    dots.innerHTML = Array.from(track.children, () => '<i></i>').join('');
    stage.insertAdjacentElement('afterend', dots);
    let last = -1;
    const sync = () => { const k = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (k === last) return; last = k; Array.prototype.forEach.call(dots.children, (d, i) => d.classList.toggle('on', i === k)); };
    track.addEventListener('scroll', sync, {passive: true}); sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
